module.exports = __webpack_public_path__ + "img/cd.a788f377.png";